import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';

const ITEMS = [
  {
    img: '/images/icon-img/Capture1.PNG',
    title: 'Experienced Faculties',
    text: 'We have best in class experienced faculties for all the subjects, to give you the right knowledge and direction.',
    link: '/about-us',
  },
  {
    img: '/images/icon-img/Capture2.PNG',
    title: 'Excellent Infrastructure',
    text: 'Our well-ventilated and well-lit infrastructure with state of the art furniture creates a conducive environment for teaching & learning.',
    link: '/about-us',
  },
  {
    img: '/images/icon-img/Capture3.PNG',
    title: 'Study Material',
    text: 'We provide the most qualitative and enriching study material, which is prepared with utmost perfection.',
    link: '/about-us',
  },
  {
    img: '/images/icon-img/Capture4.PNG',
    title: 'Internal Assessment',
    text: 'We conduct regular internal tests, in order to understand and keep a track record of the performance & progress of the students.',
    link: '/about-us',
  },
  {
    img: '/images/icon-img/Capture5.PNG',
    title: 'Overall Development',
    text: 'To bring out the potentials and inculcate values amongst students, we focus upon the overall development of the students.',
    link: '/about-us',
  },
];

export default function SpecialitiesSection() {
  return (
    <section className="sa-specialities">
      <div className="sa-container">

        {/* Header: title left, nav right */}
        <div className="sa-pub-header">
          <h2 className="sa-section-title" style={{ marginBottom: 0 }}>Our Specialities</h2>
          <div className="sa-pub-nav">
            <button className="sa-spec-prev sa-swiper-btn" aria-label="Previous">&#8592;</button>
            <button className="sa-spec-next sa-swiper-btn" aria-label="Next">&#8594;</button>
          </div>
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: '.sa-spec-prev',
            nextEl: '.sa-spec-next',
          }}
          speed={800}
          loop={true}
          spaceBetween={20}
          breakpoints={{
            0:   { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
          }}
        >
          {ITEMS.map(item => (
            <SwiperSlide key={item.title} style={{ height: 'auto' }}>
              <div className="sa-spec-card">
                <div className="sa-spec-img">
                  <img src={item.img} alt={item.title} loading="lazy" />
                </div>
                <div className="sa-spec-body">
                  <h3><Link to={item.link}>{item.title}</Link></h3>
                  <p>{item.text}</p>
                  <Link to={item.link}>Know More →</Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}
